import { REQUEST_METHOD } from '../../middlewares/services';

import * as types from './types';
import { endpoint } from '../../../config/const';

const list = (data) => ({
    type: types.SESSION_LIST,
    meta: {
        endpoint: endpoint.SESSION_LIST,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
 

const getUserinfo = (data) => ({
    type: types.SESSION_USER_INFO,
    meta: {
        endpoint: endpoint.SESSION_USER_INFO,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
export default {
    list,
    getUserinfo
}